import { useNavComponentManager } from './useNavComponentManager';
export const useMetricsStartTime = () => {
  const manager = useNavComponentManager();
  return manager.metricsStartTime;
};